export class Message
{

constructor(

public message: string,
public objet: string,
public date_created: string,
public user_id: string,
public civ: string,
public prenom: string,
public name: string,
public email: string,
public tel: string,
public adresse_line1: string,
public adresse_line2: string,
public city: string,
public zipcode: string,
public login: string,





	 ) {} 













}